import React from 'react';
import moment from 'moment';
import { cn } from '../../../components/ui/_cn';

// The mock's page-header status on Overview (spec 2026-09-21 §4.5): a dot
// with a halo and three words. Three inputs, in this order:
//   paused (the company's payout_paused setting) → nothing, because the
//     section-wide red banner in layout.js already says it, at the top of
//     every page;
//   Stripe's payoutsEnabled false → "Payouts not enabled", the word the
//     Business Details strip already uses for the same field;
//   a failed payout in the last 30 days → "A payout failed";
//   otherwise → "Payouts on schedule".
// Nothing while the payouts read is in flight: a verdict on half the
// evidence is a guess.
const FAILED_WINDOW_DAYS = 30;

const STATES = {
  notEnabled: { text: 'Payouts not enabled', dot: 'bg-fin-amber', halo: 'shadow-fin-amber-pale', color: 'text-fin-amber' },
  failed: { text: 'A payout failed', dot: 'bg-fin-red', halo: 'shadow-fin-red-pale', color: 'text-fin-red' },
  onSchedule: { text: 'Payouts on schedule', dot: 'bg-fin-green-dot', halo: 'shadow-fin-green-pale', color: 'text-fin-green' },
};

const recentlyFailed = (payouts) => {
  const since = moment.utc().subtract(FAILED_WINDOW_DAYS, 'days');
  return (payouts || []).some((row) => row.status === 'failed' && moment.utc(row.createdAt).isAfter(since));
};

const PayoutHealthLine = ({ status, payouts = [], loading = false, paused = false }) => {
  if (loading || paused) return null;
  const state = status?.payoutsEnabled === false
    ? STATES.notEnabled
    : recentlyFailed(payouts)
      ? STATES.failed
      : STATES.onSchedule;

  return (
    <p className={cn('inline-flex items-center gap-2 text-[13px] font-semibold', state.color)}>
      <span
        className={cn('h-[7px] w-[7px] rounded-full shadow-[0_0_0_3px]', state.dot, state.halo)}
        aria-hidden="true"
      />
      {state.text}
    </p>
  );
};

export default PayoutHealthLine;
